import {MouseEvent} from 'react';
import {useParams} from 'react-router-dom';

import {openLandingUrl} from '@zzng/common/utils/openLandingUrl';

import {TIARA_DETAIL_ACTION, TIARA_DETAIL_PAGE_NAME} from '@/shared/constants/tiara';
import useTiara from '@/shared/hooks/useTiara';

interface Props {
  link: string;
  value?: string;
}

const LinkField = ({link, value}: Props) => {
  const {trackEvent} = useTiara({pageName: TIARA_DETAIL_PAGE_NAME.CARD_INFO});
  const {groupCode = ''} = useParams<{groupCode: string}>();

  // link는 스킴 또는 url이 들어올 수 있음
  const onClickLink = (e: MouseEvent<HTMLAnchorElement>) => {
    openLandingUrl(link);
    e.preventDefault();
    trackEvent({
      action: TIARA_DETAIL_ACTION.CARD_INFO_LINK_CLICK,
      customProps: {link_name: value ?? '', group_code: groupCode}
    });
  };

  return (
    <dd>
      <a onClick={onClickLink} className="btn_link" href="#none" rel="noreferrer">
        {value}
        <span className="icon icon_arr_right_type10"></span>
      </a>
    </dd>
  );
};

export default LinkField;
